import React, { useEffect, useState } from "react";
import ClientService from "../../services/client.service";
import { useNavigate } from "react-router-dom";
import Default from "../../components/layouts/default";

const CompanyData_ClientsList = () => {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
 
  const [ClientDetails, setClientDetails] = useState([])

  const clientDeatils = async () => {
    
    try {
      
      const user = await ClientService.getclient()

      setClientDetails(user.clients)
    } catch (err) {
      console.log(err)
    }
  }


  useEffect(() => {
    clientDeatils()

  }, [])

  const navigate = useNavigate()
  const handlenavigate = (id) => {
    navigate(`/CompanyData/${id}`)
  }

  return (
    <Default pageTitle="Company Data">


<div className="ClientsList_container">
{ClientDetails.length > 0 ? (
      <>
        <p className="title py-2">You have {ClientDetails.length} entities registered with us</p>
  <div className="card-container">
    
        {ClientDetails.map((Details) => (
          <div className="card" key={Details.id}>
            <div className="card-body">
            <h3><a onClick={() => handlenavigate(Details.id)}>{Details.name}</a></h3>
              <p>{Details.business_structure}</p>
              <div className="address">{Details.full_address}</div>
              <a className="links" onClick={() => handlenavigate(Details.id)}>
                See Details
              </a>
            </div>
          </div>
        ))}
      
   
  </div>
  </>
   ) : (
    <p>
    No entities are registered with us. Please get in touch with our support team at{" "}
    <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
  </p>
  )}
</div>


    </Default>
  );
};

export default CompanyData_ClientsList;
